import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as modalActions } from "../../../redux/modals";

import RedeemCode from "../../../../fraction/ui/apps/library/redeem-code";
import ManageHighlighters from "../../../components/resources/manage-highlighters";
import ManageSharing from "../../../components/resources/manage-sharing";
import WelcomeOnboarding from "../../onboarding/welcome";
import BookUnavailable from "../../apps/library/book-unavailable-dialog";
import RevealCode from "../../../../fraction/ui/apps/library/courseware/RevealModal";
import Languages from "../../../../fraction/ui/apps/library/header/languages";
import Feedback from "../../../../fraction/ui/apps/library/feedback";
import InstructorModal from "../../apps/library/auto-sharing/InstructorModal";
import LearnerModal from "../../apps/library/auto-sharing/LearnerModal";
import FacultyUpload from "../../../../fraction/ui/apps/library/faculty-upload";
import Credits from "../../../../fraction/ui/apps/library/credits-dialog";
import Borrow from "../../../../fraction/ui/apps/library/explorer-tab/borrow-book-dialog";
import ExpiredBookDialog from "../../apps/library/library-tab/expired-book-dialog";
import DialogWithRefocus from "../dialog/DialogWithRefocus";

const modalComponentLookupTable = {
  RedeemModal: RedeemCode,
  HighlightersModal: ManageHighlighters,
  SharingModal: ManageSharing,
  LanguagesModal: Languages,
  FeedbackModal: Feedback,
  AutoSharingInstructorModal: InstructorModal,
  AutoSharingLearnerModal: LearnerModal,
  WelcomeOnboarding: WelcomeOnboarding,
  revealCodeModal: RevealCode,
  BookUnavailable: BookUnavailable,
  FacultyUploadModal: FacultyUpload,
  CreditsModal: Credits,
  BorrowBookModal: Borrow,
  ExpiredBook: ExpiredBookDialog
};

export class ModalManager extends Component {
  render() {
    if (this.props.type) {
      const { type, props, closeModal } = this.props;
      const ModalComponent = modalComponentLookupTable[type];
      // We need the add dialog here because of the redeem modal
      if (props.wrapWithDialog) {
        return (
          <DialogWithRefocus
            key={this.props.type}
            open
            onRequestClose={closeModal}
            formProps={props.formProps}
            rootSelector={props.rootSelector || "#bookshelf"}
            title={props.title}
            primaryActionButton={props.primaryActionButton}
            secondaryActionButton={props.secondaryActionButton}
            size={props.size || "small"}
            darkHeader={props.darkHeader}
          >
            <ModalComponent {...props} />
          </DialogWithRefocus>
        );
      }
      return (
        <ModalComponent key={this.props.type} {...props} onClose={closeModal} />
      );
    }

    return <span />;
  }
}

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(modalActions.closeModal())
});

const mapState = state => ({ ...state.modals });

export default connect(mapState, mapDispatchToProps)(ModalManager);
